
export default function SocialSection() {
  const socialLinks = [
    {
      name: 'X (Twitter)',
      icon: 'ri-twitter-x-line',
      color: '#000000',
      bgColor: '#ffffff',
      url: 'https://x.com/windies_mania',
      description: '最新情報をチェック'
    },
    {
      name: 'Instagram',
      icon: 'ri-instagram-line',
      color: '#E4405F',
      bgColor: '#E4405F20',
      url: 'https://www.instagram.com/eiji_hoshino?igsh=d2p4MWhlaXg2dXdu&utm_source=qr',
      description: '番組の裏側を公開'
    },
    {
      name: 'YouTube',
      icon: 'ri-youtube-line',
      color: '#FF0000',
      bgColor: '#FF000020',
      url: 'https://www.youtube.com/@windiesmaniayoutuber6926',
      description: '動画コンテンツ配信'
    },
    {
      name: 'Note',
      icon: 'ri-article-line',
      color: '#41C9B4',
      bgColor: '#41C9B420',
      url: 'https://note.com/windies_mania',
      description: '記事・コラムを配信'
    }
  ];

  return (
    <section id="social" className="py-24 px-6 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#ffd700]/5 to-transparent"></div>
      
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-4">
            SNSでつながろう
          </h3>
          <div className="w-24 h-1 bg-[#ff1493] mx-auto rounded-full mb-6"></div>
          <p className="text-white/70 text-lg">
            番組の最新情報やイベント告知をお届けします
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10 hover:border-white/30 transition-all duration-300 hover:transform hover:scale-105 cursor-pointer"
            >
              <div className="flex flex-col items-center text-center">
                <div 
                  className="w-20 h-20 flex items-center justify-center rounded-2xl mb-4 transition-all duration-300 group-hover:scale-110"
                  style={{ backgroundColor: social.bgColor }}
                >
                  <i 
                    className={`${social.icon} text-4xl`}
                    style={{ color: social.color }}
                  ></i>
                </div>
                <h5 className="text-xl font-bold text-white mb-2 whitespace-nowrap">{social.name}</h5>
                <p className="text-white/60 text-sm mb-4">{social.description}</p>
                <div className="flex items-center gap-2 text-white/50 group-hover:text-[#ff1493] transition-colors">
                  <span className="text-sm whitespace-nowrap">フォローする</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-br from-[#ff1493]/10 to-[#ffd700]/10 backdrop-blur-sm p-8 md:p-12 rounded-3xl border border-white/10 text-center">
          <div className="w-16 h-16 flex items-center justify-center bg-[#ff1493] rounded-full mx-auto mb-6">
            <i className="ri-notification-line text-3xl text-white"></i>
          </div>
          <h4 className="text-2xl md:text-3xl font-bold text-white mb-4">
            最新情報をお見逃しなく
          </h4>
          <p className="text-white/70 text-lg mb-8 max-w-2xl mx-auto leading-relaxed">
            番組の更新情報、ゲスト出演者の告知、イベント情報など、<br className="hidden md:block" />
            SNSで随時お知らせしています。ぜひフォローしてください！
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-all duration-300 hover:transform hover:scale-110 cursor-pointer"
                style={{ 
                  borderWidth: '2px',
                  borderStyle: 'solid',
                  borderColor: `${social.color}40`
                }}
              >
                <i 
                  className={`${social.icon} text-xl`}
                  style={{ color: social.color }}
                ></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
